import React from 'react'
import style from './PrimeraParte.module.css'

const PrimeraParte = ({ t }) => {
  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.Smartsuite.FirstPart.title')}</p>
      <div className={style.divContainer}>
        <div className={style.divIzq}>
          <p className={style.text}>{t('Products.Smartsuite.FirstPart.text2')}</p>
        </div>
        <div className={style.divDer}>
          <p className={style.text}>{t('Products.Smartsuite.FirstPart.text4')}</p>
        </div>
      </div>
    </div>
  )
}

export default PrimeraParte